import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';

interface TaskAcceptanceToggleProps {
  accepted?: boolean;
  declined?: boolean;
  onAccept: () => void;
  onDecline: () => void;
  disabled?: boolean;
}

export function TaskAcceptanceToggle({
  accepted,
  declined,
  onAccept,
  onDecline,
  disabled = false,
}: TaskAcceptanceToggleProps) {
  return (
    <div className="flex gap-3">
      {/* Accept Button */}
      <motion.button
        onClick={onAccept}
        disabled={disabled}
        className={`
          flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-heading uppercase tracking-wider text-sm transition-all
          ${
            accepted
              ? 'bg-green-600 text-white shadow-lg'
              : 'bg-green-50 text-green-700 hover:bg-green-100 border border-green-200'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
        whileHover={!disabled && !accepted ? { scale: 1.02 } : {}}
        whileTap={!disabled ? { scale: 0.98 } : {}}
      >
        <Check className={`w-5 h-5 ${accepted ? 'text-white' : 'text-green-600'}`} />
        {accepted ? 'Accepted' : 'Accept'}
      </motion.button>

      {/* Decline Button */}
      <motion.button
        onClick={onDecline}
        disabled={disabled}
        className={`
          flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-heading uppercase tracking-wider text-sm transition-all
          ${
            declined
              ? 'bg-red-600 text-white shadow-lg'
              : 'bg-red-50 text-red-700 hover:bg-red-100 border border-red-200'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
        whileHover={!disabled && !declined ? { scale: 1.02 } : {}}
        whileTap={!disabled ? { scale: 0.98 } : {}}
      >
        <X className={`w-5 h-5 ${declined ? 'text-white' : 'text-red-600'}`} />
        {declined ? 'Declined' : 'Decline'}
      </motion.button>
    </div>
  );
}
